import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddCustomer from "./pages/AddCustomer";
import CreateOrder from "./pages/CreateOrder";
import ViewOrders from "./pages/ViewOrders";
import Customers from "./pages/Customers";
import LatestCollections from "./pages/LatestCollections";
import Collections from "./pages/Collections";
import MobileOrderTable from "./pages/MobileOrderTable";
import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

function AppContent() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isAuthenticated, isValidatingSession } = useAuth();

  // Show loading while validating session
  if (isValidatingSession) {
    return (
      <div className="flex h-screen items-center justify-center bg-surface-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4"></div>
          <p className="text-secondary-600">Validating session...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Router>
      <div className="flex h-screen bg-surface-50">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="flex-1 flex flex-col">
          <TopBar onMenuClick={() => setSidebarOpen(true)} />
          <main className="flex-1 overflow-y-auto p-2 sm:p-4 md:p-6">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/add-customer" element={<AddCustomer />} />
              <Route path="/create-order" element={<CreateOrder />} />
              <Route path="/view-orders" element={<ViewOrders />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/latest-collections" element={<LatestCollections />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/mobile-orders" element={<MobileOrderTable />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
